import { createFileRoute, Outlet } from '@tanstack/react-router';
import Sidebar from '../../../components/Sidebar';
import Balance from '../../../components/Balance';
import RefundOptionBreadcrumb from '../../../components/RefundOptionBreadcrumb';
import { ScrollArea } from '../../../components/ui/scroll-area';
import { LanguagePicker } from '@/components/ui/language-picker';
import SelectEntityTypeDialog from '../../../components/SelectEntityTypeDialog';
import EconsentDialog from '../../../components/EConsentDialog';
import { EntityTypePicker } from '@/components/ui/entity-type-picker';

export const Route = createFileRoute('/payments/_authenticated/_layouts')({
  component: () => (
    <div className='flex h-screen w-screen flex-col md:flex-row'>
      <Sidebar />

      <ScrollArea className='h-full max-h-[100vh] w-full flex-1 overflow-y-auto bg-secondary md:h-[initial]'>
        <div className='relative flex w-full justify-center px-5 py-4'>
          <div className='w-full max-w-[1200px]'>
            <div className='mb-3 flex items-center justify-between'>
              <RefundOptionBreadcrumb />
              <div className='hidden items-center gap-2 lg:flex'>
                <EntityTypePicker />
                <LanguagePicker />
              </div>
              <SelectEntityTypeDialog />
            </div>
            <Balance />
            <Outlet />
          </div>
        </div>
      </ScrollArea>
      <EconsentDialog />
    </div>
  ),
});
